export default __webpack_public_path__ + "static/media/farmAdminLogo.98771a36.svg";